import React from "react";
import { Link } from "react-router-dom";
import { graphql } from "@apollo/client/react/hoc";
import flowRight from "lodash/flowRight";

import Panel from "ui/Panel";
import withLoading from "ui/Loading/withLoading";

import QUERY from "./Query.graphql";

import { PostgresRoleList as PostgresRoleListType } from "./types/PostgresRoleList";
import { useRoutes } from "utils/routes";
import Grid from "ui/Grid";
import { makeFilter } from "utils/filter";
import { useQueryStringSearch } from "ui/QueryStringSearch";

type Props = {
  data: PostgresRoleListType;
  serverId: string;
};

const PostgresRoleList: React.FunctionComponent<Props> = ({
  data,
  serverId,
}) => {
  const { serverRole } = useRoutes();
  const [searchTerm, SearchInput] = useQueryStringSearch("q");

  const postgresRoles = data.getPostgresRoles.filter(
    makeFilter(searchTerm, "name"),
  );

  return (
    <Panel title="All Roles" secondaryTitle={<SearchInput />}>
      <Grid
        striped
        data={postgresRoles}
        columns={[
          {
            field: "name",
            header: "Name",
            width: "1fr",
            renderer: function NameCell({ rowData }) {
              return (
                <Link to={serverRole(serverId, rowData.id)}>
                  {rowData.name}
                </Link>
              );
            },
          },
          {
            field: "login",
            header: "Login",
            width: "100px",
            defaultSortOrder: "DESC",
            nullValue: "?",
            renderer: YesNoCell,
          },
          {
            field: "superUser",
            header: "Super User",
            width: "100px",
            defaultSortOrder: "DESC",
            nullValue: "?",
            renderer: YesNoCell,
          },
        ]}
        defaultSortBy="name"
      />
    </Panel>
  );
};

function YesNoCell({ fieldData }: { fieldData: boolean }) {
  return fieldData ? "Yes" : "No";
}

export default flowRight(graphql(QUERY), withLoading)(PostgresRoleList);
